import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

const styles = {};
class Login extends React.Component {
  render() {
    return <div>Login</div>;
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js